import { createRouter, createWebHashHistory } from 'vue-router'

// 路由级代码分割（懒加载）
const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/HomePage.vue'),
    meta: { title: '首页' }
  },
  {
    path: '/Project',
    name: 'ProjCenter',
    component: () => import('@/views/ProjCenter.vue'),
    meta: { title: '项目' }
  },
  {
    path: '/Project/PKUAutoElective',
    redirect: '/AccessWarning',
    name: 'PKUAutoElective',
    component: () => import('@/views/ProjCenter.vue'),
    meta: { title: '北大刷课机' }
  },
  {
    path: '/Project/PKUAutoRun',
    redirect: '/AccessWarning',
    name: 'PKUAutoRun',
    component: () => import('@/views/ProjCenter.vue'),
    meta: { title: '北大自动跑步' }
  },
  {
    path: '/Project/GlaringUniverse',
    redirect: '/ContentWarning',
    name: 'GlaringUniverse',
    component: () => import('@/views/ProjCenter.vue'),
    meta: { title: '瞪眼宇宙' }
  },
  {
    path: '/Project/Yanxx_ChineseLearning',
    name: 'Yanxx_ChineseLearning',
    component: () => import('@/views/project/Yanxx_ChineseLearning.vue'),
    meta: { title: '严小希-语文学习小助手' }
  },
  {
    path: '/Project/Yanxx_location',
    name: 'Yanxx_location',
    component: () => import('@/views/project/Yanxx_location.vue'),
    meta: { title: '严小希-地理定位小助手' }
  },
  {
    path: '/Project/CalendarSystem',
    name: 'CalendarSystem',
    component: () => import('@/views/project/CalendarSystem.vue'),
    meta: { title: '严小希-日程管理小助手' }
  },
  {
    path: '/Yanxx_Introduction',
    name: 'Yanxx_Introduction',
    component: () => import('@/views/YanxxIntroduchtion.vue'),
    meta: { title: '严小希-自我介绍' }
  },
  {
    path: '/Project/RenjuGame',
    name: 'RenjuGame',
    component: () => import('@/views/project/RenjuGame.vue'),
    meta: { title: 'Renju 五子棋' }
  },
  {
    path: '/Project/PKUAutoElective/2025Autumn',
    name: 'PKUAutoElective2025Autumn',
    component: () => import('@/views/project/PKUElective2025Autumn.vue'),
    meta: { title: 'PKUElective2025Autumn' }
  },
  {
    path: '/Project/PKUVideo/2025Autumn',
    name: 'PKUVideo2025Autumn',
    component: () => import('@/views/project/PKUVideo2025Autumn.vue'),
    meta: { title: 'PKUVideo2025Autumn' }
  },
  {
    path: '/AccessWarning',
    name: 'AccessWarning',
    component: () => import('@/views/AccessWarning.vue'),
    meta: { title: '权限不足警告' }
  },
  {
    path: '/ContentWarning',
    name: 'ContentWarning',
    component: () => import('@/views/ContentWarning.vue'),
    meta: { title: '内容仍在开发中' }
  },
  {
    path: '/ContactAdmin',
    name: 'ContactAdmin',
    component: () => import('@/views/ContactAdmin.vue'),
    meta: { title: '联系管理员' }
  },
  {
    path: '/Article/Model',
    name: 'ArticleModel',
    component: () => import('@/views/article/PageModel_DO_NOT_DELETE.vue'),
    meta: { title: '文章模板' }
  },
  {
    path: '/Article/XingguangWufaZhaoliangZhichu/1',
    name: 'XingguangWufaZhaoliangZhichu_1',
    component: () => import('@/views/article/XingguangWufaZhaoliangZhichu_1.vue'),
    meta: { title: '星光无法照亮之处-1' }
  },
  {
    path: '/Article/XingguangWufaZhaoliangZhichu/2',
    name: 'XingguangWufaZhaoliangZhichu_2',
    component: () => import('@/views/article/XingguangWufaZhaoliangZhichu_2.vue'),
    meta: { title: '星光无法照亮之处-2' }
  },
  {
    path: '/Article/XingguangWufaZhaoliangZhichu/3',
    name: 'XingguangWufaZhaoliangZhichu_3',
    component: () => import('@/views/article/XingguangWufaZhaoliangZhichu_3.vue'),
    meta: { title: '星光无法照亮之处-3' }
  },
  {
    path: '/Article/XingguangWufaZhaoliangZhichu/4',
    name: 'XingguangWufaZhaoliangZhichu_4',
    component: () => import('@/views/article/XingguangWufaZhaoliangZhichu_4.vue'),
    meta: { title: '星光无法照亮之处-4' }
  },
  {
    path: '/Article/XingguangWufaZhaoliangZhichu/5',
    name: 'XingguangWufaZhaoliangZhichu_5',
    component: () => import('@/views/article/XingguangWufaZhaoliangZhichu_5.vue'),
    meta: { title: '星光无法照亮之处-5' }
  },
  {
    path: '/Article/WeimingHupanNaYingxing',
    name: 'WeimingHupanNaYingxing',
    component: () => import('@/views/article/WeimingHupanNaYinxing.vue'),
    meta: { title: '未名湖畔那银杏' }
  },
  {
    path: '/Course',
    redirect : '/ContentWarning',
    name: 'CourseCenter',
    component: () => import('@/views/CourseCenter.vue'),
    meta: { title: '文章模板' }
  },
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  
  // 添加滚动行为控制
  scrollBehavior(to, from, savedPosition) {
    // 1. 如果有保存的位置（如浏览器后退/前进），则恢复位置
    if (savedPosition) {
      return savedPosition
    }
    
    // 2. 对于文章路由，总是滚动到顶部
    if (to.path.startsWith('/Article/')) {
      return { top: 0 }
    }
    
    // 3. 其他路由也滚动到顶部
    return { top: 0 }
  }
})

export default router